import React, { useCallback, useEffect, useMemo, useState } from "react";
import {
  Modal, ModalHeader, ModalBody, ModalFooter, Button, Spinner,
  Input, Alert, Table, Badge, Nav, NavItem, NavLink, TabContent, TabPane,
} from "reactstrap";
import classnames from "classnames";

const BASE_URL = "https://harmanappapi.stechomeyazilim.info";

// Alan sırası panelin geri kalanıyla tutarlı olsun diye sabit.
const ALANLAR = [
  { key: "MezatDenemeHakki", label: "Mezat Deneme", color: "warning", not: "Ücretsiz 5 dk'lık deneme mezatı" },
  { key: "VitrinHakki", label: "Vitrin", color: "primary", not: "İlanı vitrine çıkarma" },
  { key: "ModeratorHakki", label: "Moderatör", color: "info", not: "Mezata moderatör atama" },
  { key: "KalinYaziHakki", label: "Kalın Yazı", color: "dark", not: "İlan başlığı kalın" },
  { key: "CerceveHakki", label: "Çerçeve", color: "secondary", not: "İlan çerçevesi" },
];

const HAK_ETIKET = {
  ILAN: "İlan", MEZAT: "Mezat", MEZAT_UZATMA: "Mezat Uzatma", DEGERLEME: "Değerleme",
  VITRIN: "Vitrin", MODERATOR: "Moderatör", KALIN_YAZI: "Kalın Yazı",
  CERCEVE: "Çerçeve", MEZAT_DENEME: "Mezat Deneme",
};

const KAYNAK_RENK = {
  ADMIN: "primary", TOPLU: "info", SATIN_ALMA: "success",
  TUKETIM: "secondary", IADE: "warning", KAYIT: "light",
};

/**
 * Kozmetik / ekstra hak yönetimi + hak hareket geçmişi.
 *
 * Bu haklar (vitrin, moderatör, kalın yazı, çerçeve, mezat deneme)
 * KULLANICI_COSMETIC_HAKLARI tablosunda tutulur. Tablo EDMX'te olmadığı için
 * OData ile açılamıyor; bu yüzden düz Web API ucu kullanılır:
 *   GET  /api/AdminHak/Kozmetik?kullaniciId=..
 *   POST /api/AdminHak/Kozmetik
 *   GET  /api/AdminHak/Hareketler?kullaniciId=..
 */
const KozmetikHakModal = ({ isOpen, toggle, user, headers, onSaved }) => {
  const [tab, setTab] = useState("1");
  const [veri, setVeri] = useState(null);
  const [taslak, setTaslak] = useState({});
  const [aciklama, setAciklama] = useState("");
  const [hareketler, setHareketler] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [isLogLoading, setIsLogLoading] = useState(false);
  const [isSaving, setIsSaving] = useState(false);
  const [hata, setHata] = useState(null);

  const yukle = useCallback(async () => {
    if (!user?.ID) return;
    setIsLoading(true);
    setHata(null);
    try {
      const res = await fetch(`${BASE_URL}/api/AdminHak/Kozmetik?kullaniciId=${user.ID}`, { headers });
      if (!res.ok) {
        setHata(res.status === 403
          ? "Bu işlem için yönetici yetkisi gerekiyor."
          : "Kozmetik haklar yüklenemedi.");
        return;
      }
      const json = await res.json();
      setVeri(json);
      const t = {};
      ALANLAR.forEach((a) => { t[a.key] = json[a.key] ?? 0; });
      setTaslak(t);
    } catch {
      setHata("Kozmetik haklar yüklenemedi.");
    } finally {
      setIsLoading(false);
    }
  }, [user, headers]);

  const yukleHareketler = useCallback(async () => {
    if (!user?.ID) return;
    setIsLogLoading(true);
    try {
      const res = await fetch(`${BASE_URL}/api/AdminHak/Hareketler?kullaniciId=${user.ID}&top=300`, { headers });
      if (res.ok) setHareketler(await res.json());
    } catch {
      // geçmiş yüklenemezse sessiz geç — asıl işlev hak düzenleme
    } finally {
      setIsLogLoading(false);
    }
  }, [user, headers]);

  useEffect(() => {
    if (!isOpen) return;
    setTab("1");
    setAciklama("");
    yukle();
    yukleHareketler();
  }, [isOpen, yukle, yukleHareketler]);

  const setDeger = (key, val) => {
    const n = Math.max(0, Number.isFinite(Number(val)) ? Math.trunc(Number(val)) : 0);
    setTaslak((p) => ({ ...p, [key]: n }));
  };
  const artir = (key, d) =>
    setTaslak((p) => ({ ...p, [key]: Math.max(0, (p[key] || 0) + d) }));

  const degisenler = useMemo(() => {
    if (!veri) return [];
    return ALANLAR.filter((a) => (veri[a.key] ?? 0) !== (taslak[a.key] ?? 0));
  }, [veri, taslak]);

  const kaydet = async () => {
    if (degisenler.length === 0) { toggle(); return; }
    setIsSaving(true);
    setHata(null);
    try {
      const res = await fetch(`${BASE_URL}/api/AdminHak/Kozmetik`, {
        method: "POST",
        headers,
        body: JSON.stringify({
          KullaniciId: user.ID,
          KalinYaziHakki: taslak.KalinYaziHakki ?? 0,
          CerceveHakki: taslak.CerceveHakki ?? 0,
          VitrinHakki: taslak.VitrinHakki ?? 0,
          ModeratorHakki: taslak.ModeratorHakki ?? 0,
          MezatDenemeHakki: taslak.MezatDenemeHakki ?? 0,
          Aciklama: aciklama || null,
        }),
      });
      if (!res.ok) {
        const d = await res.json().catch(() => ({}));
        setHata(d.message || d.Message || "Kayıt başarısız.");
        return;
      }
      if (onSaved) onSaved(degisenler.length);
      toggle();
    } catch {
      setHata("Kayıt sırasında hata oluştu.");
    } finally {
      setIsSaving(false);
    }
  };

  const tarihYaz = (t) => {
    if (!t) return "—";
    try { return new Date(t).toLocaleString("tr-TR"); } catch { return t; }
  };

  return (
    <Modal isOpen={isOpen} toggle={toggle} centered size="lg" scrollable>
      <ModalHeader toggle={toggle}>
        <i className="mdi mdi-star-circle-outline me-2 text-warning" />
        Ekstra Haklar — {user?.AD_SOYAD || user?.Mail_Adress}{" "}
        <small className="text-muted">(#{user?.ID})</small>
      </ModalHeader>

      <ModalBody>
        {hata && <Alert color="danger" toggle={() => setHata(null)}>{hata}</Alert>}

        <Nav tabs className="mb-3">
          <NavItem>
            <NavLink className={classnames({ active: tab === "1" })}
              style={{ cursor: "pointer" }} onClick={() => setTab("1")}>
              Haklar
            </NavLink>
          </NavItem>
          <NavItem>
            <NavLink className={classnames({ active: tab === "2" })}
              style={{ cursor: "pointer" }} onClick={() => setTab("2")}>
              Hak Geçmişi {hareketler.length > 0 && <Badge color="light" className="text-muted ms-1">{hareketler.length}</Badge>}
            </NavLink>
          </NavItem>
        </Nav>

        <TabContent activeTab={tab}>
          {/* ---- HAKLAR ---- */}
          <TabPane tabId="1">
            {isLoading ? (
              <div className="text-center py-5"><Spinner color="primary" /></div>
            ) : !veri ? (
              <p className="text-muted">Veri yok.</p>
            ) : (
              <>
                {!veri.KayitVar && (
                  <Alert color="info" className="py-2">
                    Bu kullanıcının henüz kozmetik hak kaydı yok. Kaydettiğinizde oluşturulacak.
                  </Alert>
                )}

                <div className="table-responsive">
                  <Table className="table-sm align-middle mb-0">
                    <thead className="table-light">
                      <tr>
                        <th>Hak</th>
                        <th className="text-center" style={{ minWidth: 190 }}>Adet</th>
                      </tr>
                    </thead>
                    <tbody>
                      {ALANLAR.map((a) => {
                        const degisti = degisenler.some((d) => d.key === a.key);
                        return (
                          <tr key={a.key} className={degisti ? "table-warning" : undefined}>
                            <td>
                              <Badge color={a.color} className="me-2">{a.label}</Badge>
                              <small className="text-muted">{a.not}</small>
                              {degisti && (
                                <small className="text-muted ms-2">
                                  ({veri[a.key] ?? 0} → {taslak[a.key] ?? 0})
                                </small>
                              )}
                            </td>
                            <td>
                              <div className="d-flex align-items-center justify-content-center gap-1">
                                <Button color="light" size="sm" className="px-2"
                                  onClick={() => artir(a.key, -1)}
                                  disabled={(taslak[a.key] || 0) <= 0}>−</Button>
                                <Input type="number" bsSize="sm" min="0"
                                  className="text-center px-1" style={{ width: 66 }}
                                  value={taslak[a.key] ?? 0}
                                  onChange={(e) => setDeger(a.key, e.target.value)} />
                                <Button color="light" size="sm" className="px-2"
                                  onClick={() => artir(a.key, 1)}>+</Button>
                                <Button color="link" size="sm" className="px-1 text-primary"
                                  onClick={() => artir(a.key, 5)} title="+5">+5</Button>
                              </div>
                            </td>
                          </tr>
                        );
                      })}
                    </tbody>
                  </Table>
                </div>

                <div className="mt-3">
                  <label className="form-label fw-bold small mb-1">
                    Açıklama <span className="text-muted fw-normal">(hak geçmişine yazılır)</span>
                  </label>
                  <Input type="text" bsSize="sm" maxLength={500}
                    placeholder="ör. iade telafisi, kampanya hediyesi, destek talebi #123"
                    value={aciklama} onChange={(e) => setAciklama(e.target.value)} />
                </div>
              </>
            )}
          </TabPane>

          {/* ---- HAK GEÇMİŞİ ---- */}
          <TabPane tabId="2">
            {isLogLoading ? (
              <div className="text-center py-5"><Spinner color="primary" /></div>
            ) : hareketler.length === 0 ? (
              <p className="text-muted mb-0">
                Bu kullanıcı için kayıtlı hak hareketi yok. (Defter yeni açıldıysa
                yalnızca bundan sonraki değişiklikler görünür.)
              </p>
            ) : (
              <div className="table-responsive">
                <Table className="table-sm align-middle mb-0">
                  <thead className="table-light">
                    <tr>
                      <th>Tarih</th>
                      <th>Hak</th>
                      <th className="text-center">Değişim</th>
                      <th>Kaynak</th>
                      <th>Yapan</th>
                      <th>Açıklama</th>
                    </tr>
                  </thead>
                  <tbody>
                    {hareketler.map((h) => (
                      <tr key={h.ID}>
                        <td className="text-nowrap"><small>{tarihYaz(h.TARIH)}</small></td>
                        <td>
                          <small>{HAK_ETIKET[h.HAK_TIPI] || h.HAK_TIPI}</small>
                          {h.KategoriAd && <><br /><small className="text-muted">{h.KategoriAd}</small></>}
                        </td>
                        <td className="text-center text-nowrap">
                          <Badge color={h.DEGISIM > 0 ? "success" : "danger"}>
                            {h.DEGISIM > 0 ? `+${h.DEGISIM}` : h.DEGISIM}
                          </Badge>
                          <br />
                          <small className="text-muted">{h.ONCEKI_DEGER} → {h.YENI_DEGER}</small>
                        </td>
                        <td><Badge color={KAYNAK_RENK[h.KAYNAK] || "secondary"}>{h.KAYNAK}</Badge></td>
                        <td><small>{h.YapanAd || <span className="text-muted">sistem</span>}</small></td>
                        <td><small className="text-muted">{h.ACIKLAMA || "—"}</small></td>
                      </tr>
                    ))}
                  </tbody>
                </Table>
              </div>
            )}
          </TabPane>
        </TabContent>
      </ModalBody>

      <ModalFooter>
        <Button color="secondary" outline onClick={toggle} disabled={isSaving}>Kapat</Button>
        {tab === "1" && (
          <Button color="primary" onClick={kaydet}
            disabled={isSaving || isLoading || degisenler.length === 0}>
            {isSaving ? <Spinner size="sm" className="me-1" /> : <i className="mdi mdi-content-save me-1" />}
            {degisenler.length > 0 ? `Kaydet (${degisenler.length})` : "Kaydet"}
          </Button>
        )}
      </ModalFooter>
    </Modal>
  );
};

export default KozmetikHakModal;
